export default function Reasons() {
  const reasons = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '明朗会計・追加料金なし',
      description: 'お見積り後の追加料金は一切ございません。安心してご依頼いただけます。'
    },
    {
      icon: 'ri-medal-line',
      title: '専門資格者在籍',
      description: '遺品整理士などの専門資格を持つスタッフが、責任を持って対応いたします。'
    },
    {
      icon: 'ri-user-smile-line',
      title: '女性スタッフ在籍',
      description: '女性のお客様も安心してご依頼いただけるよう、女性スタッフが対応いたします。'
    },
    {
      icon: 'ri-flashlight-line',
      title: '迅速な対応・即日対応',
      description: 'お急ぎの場合も最短即日で対応可能です。お気軽にご相談ください。'
    },
    {
      icon: 'ri-building-line',
      title: 'ご供養提携寺院あり',
      description: '提携寺院と連携し、大切な遺品のご供養も承ります。'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'プライバシー完全厳守',
      description: 'お客様の個人情報や作業内容は厳重に管理し、秘密を厳守いたします。'
    },
    {
      icon: 'ri-trophy-line',
      title: '年間2,800件以上の実績',
      description: '豊富な経験と実績で、お客様に信頼されるサービスを提供しております。'
    },
    {
      icon: 'ri-heart-line',
      title: '丁寧な対応と心配り',
      description: 'ご遺族の気持ちに寄り添い、一つひとつ丁寧に対応させていただきます。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">選ばれる理由</h2>
          <p className="text-lg text-gray-600">
            多くのお客様に信頼していただいている8つの理由
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-pink-50 to-white p-6 rounded-xl border border-pink-100 hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="bg-green-600 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto">
                <i className={`${reason.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3 text-center">
                {reason.title}
              </h3>
              <p className="text-sm text-gray-600 text-center leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
